const SpaceDebrisMonitor = () => {
    return (<>
        <div className="monitor space-debris">
            <div className="title">
                <h1>
                    Space Debris
                </h1>
            </div>

            <div className="content">
                <h1>clear</h1>
                {/* <div className="null">
                    <h1>
                        //InDev
                    </h1>
                </div> */}
            </div>
        </div>
    </>);
}
 
export default SpaceDebrisMonitor;